// Calcul du devis Espagne — règles existantes (2 pleins tarifs par chambre, réductions enfant/bébé et supplément individuel propres au séjour)
export const PISCINE = { court: 40, semaine: 80 };
export const piscineForWeek = (w) => (w.nights <= 4 ? PISCINE.court : PISCINE.semaine);

export const LITERIE = {
  '': 'Literie : sans préférence',
  separes: 'Literie souhaitée : deux lits séparés.',
  couple: 'Literie souhaitée : configuration couple — grand lit non garanti, deux lits simples rapprochés possibles.',
};

export const fmtEuro = (n) => `${Number(n || 0).toLocaleString('fr-FR')} €`;

export const fmtDateFr = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

export const parseDob = (s) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((s || '').trim());
  if (!m) return null;
  const [, d, mo, y] = m;
  const dt = new Date(Date.UTC(+y, +mo - 1, +d));
  if (dt.getUTCFullYear() !== +y || dt.getUTCMonth() !== +mo - 1 || dt.getUTCDate() !== +d) return null;
  return `${y}-${mo}-${d}`;
};

export const maskDob = (raw) => {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const ageAt = (iso, refIso) => {
  const b = new Date(iso + 'T00:00:00Z');
  const r = new Date(refIso + 'T00:00:00Z');
  let age = r.getUTCFullYear() - b.getUTCFullYear();
  const m = r.getUTCMonth() - b.getUTCMonth();
  if (m < 0 || (m === 0 && r.getUTCDate() < b.getUTCDate())) age--;
  return age;
};

export const dobStatus = (dob, startIso) => {
  if (!dob) return { vide: true };
  const iso = parseDob(dob);
  if (!iso) return { error: 'Date invalide (JJ/MM/AAAA)' };
  if (startIso && iso > startIso) return { error: 'Date postérieure au départ' };
  const age = startIso ? ageAt(iso, startIso) : null;
  if (age !== null && age > 110) return { error: 'Date invalide' };
  return { iso, age };
};

export const categorie = (age, regles) => (age < regles.age_bebe ? 'baby' : age < regles.age_enfant ? 'child' : 'adult');

export const legFull = (wk, leg) => {
  const r = wk?.dispo?.avec?.trajets?.[leg]?.restantes;
  return r !== undefined && r !== -1 && r <= 0;
};
export const legOk = (wk, leg) => !!(wk && wk.ids?.avec && wk.prixTrajet && !legFull(wk, leg));
export const legWeeks = (weeks) => ({ aller: weeks[0], retour: weeks[weeks.length - 1] });

export const newTraveler = (car) => ({ dob: '', aller: car, retour: car });
export const newRoom = (active, car) => ({ active, nb: 2, travelers: [newTraveler(car), newTraveler(car)], literie: '', piscine: false });

export const calcRoom = (room, weeks, regles) => {
  const start = weeks[0].start;
  const travs = room.travelers.slice(0, room.nb).map((t, i) => ({ ...t, pos: i + 1, st: dobStatus(t.dob, start) }));
  const complete = travs.every((t) => t.st.iso);
  const sumW = (f) => weeks.reduce((s, w) => s + f(w), 0);
  const lw = legWeeks(weeks);
  const transport = { aller: 0, retour: 0, nAller: 0, nRetour: 0 };
  travs.forEach((t) => {
    if (t.aller && legOk(lw.aller, 'aller')) { transport.aller += lw.aller.prixTrajet; transport.nAller++; }
    if (t.retour && legOk(lw.retour, 'retour')) { transport.retour += lw.retour.prixTrajet; transport.nRetour++; }
  });
  const piscine = room.piscine ? sumW(piscineForWeek) : 0;
  if (!complete) return { complete: false, travs, transport, piscine, literie: room.literie, lines: [], supplement: 0, hotel: 0, adults: 0 };
  travs.forEach((t) => { t.cat = categorie(t.st.age, regles); });
  const base = sumW((w) => w.basePrice);
  const catLabel = (cat, d) => (cat === 'baby' ? `BÉBÉ −${d} €` : `ENFANT −${d} €`);
  const mk = (t, discount, statut) => ({ pos: t.pos, age: t.st.age, cat: t.cat, statut, discount, total: Math.max(0, base - discount) });
  const lines = [];
  let supplement = 0;
  let optimized = false;
  let isSingle = travs.length === 1;
  if (travs.length === 1) {
    lines.push(mk(travs[0], 0, 'PLEIN TARIF'));
    supplement = sumW((w) => w.singleSupplement);
  } else if (travs.length === 2) {
    let best = null;
    for (let si = 0; si < 2; si++) {
      const o = travs[1 - si];
      if (o.cat === 'adult') continue;
      const disc = sumW((w) => (o.cat === 'baby' ? w.babyDiscount : w.childDiscount));
      const alt = base + sumW((w) => w.singleSupplement) + Math.max(0, base - disc);
      if (alt < 2 * base && (!best || alt < best.alt)) best = { si, disc, alt };
    }
    if (best) {
      optimized = true;
      isSingle = true;
      supplement = sumW((w) => w.singleSupplement);
      travs.forEach((t, i) => lines.push(i === best.si ? mk(t, 0, 'PLEIN TARIF + suppl. individuel') : mk(t, best.disc, catLabel(t.cat, best.disc))));
    } else {
      travs.forEach((t) => lines.push(mk(t, 0, 'PLEIN TARIF')));
    }
  } else {
    // 2 pleins tarifs : les 2 plus âgés (hors bébés) ; égalité d'âge → ordre de saisie
    const nonBaby = [...travs].filter((t) => t.cat !== 'baby').sort((a, b) => b.st.age - a.st.age || a.pos - b.pos);
    const full = new Set(nonBaby.slice(0, 2).map((t) => t.pos));
    travs.forEach((t) => {
      if (t.cat === 'baby') { const d = sumW((w) => w.babyDiscount); lines.push(mk(t, d, catLabel('baby', d))); }
      else if (t.cat === 'child' && !full.has(t.pos)) { const d = sumW((w) => w.childDiscount); lines.push(mk(t, d, catLabel('child', d))); }
      else lines.push(mk(t, 0, 'PLEIN TARIF'));
    });
  }
  const hotel = lines.reduce((s, l) => s + l.total, 0) + supplement + piscine;
  return { complete: true, travs, lines, supplement, isSingle, optimized, piscine, hotel, transport, literie: room.literie, adults: travs.filter((t) => t.cat === 'adult').length };
};

export const calcDevis = (rooms, weeks, regles, withInsurance) => {
  if (!weeks.length) return null;
  const chambres = rooms.map((r, i) => ({ num: i + 1, ...(r.active ? calcRoom(r, weeks, regles) : { active: false }) , active: r.active })).filter((c) => c.active);
  const complete = chambres.every((c) => c.complete);
  const tooManyAdults = chambres.some((c) => c.adults > 3);
  const aller = chambres.reduce((s, c) => s + c.transport.aller, 0);
  const retour = chambres.reduce((s, c) => s + c.transport.retour, 0);
  const nb = chambres.reduce((s, c) => s + c.travs.length, 0);
  const adhesion = Number(regles.adhesion) || 0;
  const prixAssurance = Number(weeks[0].assurance ?? regles.assurance) || 0;
  const assurance = withInsurance ? nb * prixAssurance : 0;
  const hotel = chambres.reduce((s, c) => s + c.hotel, 0);
  const nights = weeks.reduce((s, w) => s + w.nights, 0);
  return { chambres, complete, tooManyAdults, aller, retour, nb, adhesion, assurance, prixAssurance, hotel, nights, total: hotel + aller + retour + adhesion + assurance, hasCar: chambres.some((c) => c.transport.nAller || c.transport.nRetour) };
};
